
import React from 'react';

const OtherAdvance = () => {
  const transactions = [
    { date: '10/08/2025', purpose: 'दूध विक्री', debit: 3000, credit: 0 },
    { date: '12/08/2025', purpose: 'दूध विक्री', debit: 2000, credit: 0 },
    { date: '14/08/2025', purpose: 'जमा रक्कम', debit: 0, credit: 1000 },
    { date: '15/08/2025', purpose: 'प्रॉडक्ट विक्री', debit: 1500, credit: 0 },
    { date: '20/08/2025', purpose: 'बिल कपात-जमा ', debit: 0, credit: 500 },
  ];

  return (
    <div style={{ padding: '10px' }}>
      <h3 style={{ marginBottom: '10px' }}>प्रॉडक्ट / दूध विक्री</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#f2f2f2' }}>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>दिनांक</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>नावे रक्कम</th>
            <th style={{ border: '1px solid #ccc', padding: '8px' }}>जमा रक्कम (₹)</th>
          </tr>
        </thead>
        <tbody>
          {transactions.map((item, index) => (
            <tr key={index}>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>{item.date}</td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                {item.debit > 0 ? `₹${item.debit}` : ''}
              </td>
              <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                {item.credit > 0 ? `₹${item.credit}` : ''}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default OtherAdvance;
